import React from "react";

import { Card, CardContent } from "../../ui/card";

export default function FormContextSelector({
  forms,
  selectedFormId,
  selectedForm,
  onSelect,
  description,
  selectId = "form-context-selector",
  dataTestId = "form-context-selector",
  emptyMessage = "Es sind noch keine Formulare vorhanden.",
}) {
  const hasForms = forms.length > 0;
  const currentValue = selectedFormId || selectedForm?.id || forms[0]?.id || "";

  return (
    <Card className="border-border/70 bg-card/80 shadow-sm">
      <CardContent className="space-y-3 pt-6">
        <div className="space-y-1">
          <label className="text-sm font-medium" htmlFor={selectId}>
            Formular auswählen
          </label>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>

        {hasForms ? (
          <select
            id={selectId}
            data-testid={dataTestId}
            className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm"
            value={currentValue}
            disabled={forms.length === 1}
            onChange={(event) => onSelect(event.target.value)}
          >
            {forms.map((form) => (
              <option key={form.id} value={form.id}>
                {form.name || "Unbenanntes Formular"}
              </option>
            ))}
          </select>
        ) : (
          <div className="rounded-lg border border-dashed border-border/80 px-3 py-3 text-sm text-muted-foreground">
            {emptyMessage}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
